import { config } from "config";

export const environment = {
  production: true,
  apiURL: config.prodApiUrl,
  syncFusionLicense: config.syncFusionLicense,
  company: 'nexus',
  iconLogo: 'assets/images/logo/logo_big.png',
  coverLogo: 'assets/images/logo/logo_cover.svg',
  theme: 'theme-nexus',
  
  clientId: "1cecc18c-7530-4213-9b38-04e47f9f668d",
  authority: "https://login.microsoftonline.com/fde50129-d08d-4a40-8e42-d86960245c6c",
  accessAsUserScope: "api://1cecc18c-7530-4213-9b38-04e47f9f668d/access_as_user",
};
